/**
 * Security Request Headers Utilities
 *
 * Generates security headers for outgoing API requests to protect against
 * various attacks when communicating with backend services.
 */

/**
 * Generates security headers for outgoing API requests
 *
 * Adds security headers to axios requests to protect against various attacks
 * even when communicating with backend services.
 */
export const getSecureRequestHeaders = (token?: string) => ({
  ...(token && { Authorization: `Bearer ${token}` }),
  'X-Content-Type-Options': 'nosniff', // Prevent MIME sniffing
  'X-Frame-Options': 'DENY', // Prevent framing (works in HTTP headers)
  'X-XSS-Protection': '1; mode=block', // XSS protection
});
